/**
 * Talala API Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { OfferImage } from './offerImage';


export interface PaymentMethodApple { 
    /**
     * Unique identifier of the payment method
     */
    id?: string;
    /**
     * Unique identifier of the product in Apple Store
     */
    product_id?: string;
    image?: OfferImage;
}

